/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseHotspotContentFragment, HotspotContentFragment, FullHotspotContentFragment} from '@amblique/contentful/app/contentful/fragments/hotspot-content';

/**
 * Get a single HotspotContent by ID (base - scalars only)
 */
export const getBaseHotspotContentById = gql`
  ${BaseHotspotContentFragment}

  query GetBaseHotspotContentById($id: String!, $locale: String!, $preview: Boolean) {
    hotspotContent(id: $id, locale: $locale, preview: $preview) {
      ...BaseHotspotContentFragment
    }
  }
`;

/**
 * Get a single HotspotContent by ID (standard - 1 level deep)
 */
export const getHotspotContentById = gql`
  ${HotspotContentFragment}

  query GetHotspotContentById($id: String!, $locale: String!, $preview: Boolean) {
    hotspotContent(id: $id, locale: $locale, preview: $preview) {
      ...HotspotContentFragment
    }
  }
`;

/**
 * Get a single HotspotContent by ID (full - 2 levels deep)
 */
export const getFullHotspotContentById = gql`
  ${FullHotspotContentFragment}

  query GetFullHotspotContentById($id: String!, $locale: String!, $preview: Boolean) {
    hotspotContent(id: $id, locale: $locale, preview: $preview) {
      ...FullHotspotContentFragment
    }
  }
`;

/**
 * Get all HotspotContent entries with pagination (base - scalars only)
 */
export const getBaseHotspotContents = gql`
  ${BaseHotspotContentFragment}

  query GetBaseHotspotContents(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [HotspotContentOrder]
    $where: HotspotContentFilter
    $preview: Boolean
  ) {
    hotspotContentCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseHotspotContentFragment
      }
    }
  }
`;

/**
 * Get all HotspotContent entries with pagination (standard - 1 level deep)
 */
export const getHotspotContents = gql`
  ${HotspotContentFragment}

  query GetHotspotContents(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [HotspotContentOrder]
    $where: HotspotContentFilter
    $preview: Boolean
  ) {
    hotspotContentCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...HotspotContentFragment
      }
    }
  }
`;

/**
 * Get all HotspotContent entries with pagination (full - 2 levels deep)
 */
export const getFullHotspotContents = gql`
  ${FullHotspotContentFragment}

  query GetFullHotspotContents(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [HotspotContentOrder]
    $where: HotspotContentFilter
    $preview: Boolean
  ) {
    hotspotContentCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullHotspotContentFragment
      }
    }
  }
`;
